import styles from "./SkeletonLoader.module.css";

export const ConversationSkeleton = () => (
  <div className={styles.convItem}>
    <div className={`${styles.circle} ${styles.sk}`} />
    <div className={styles.lines}>
      <div className={`${styles.line} ${styles.lineLong} ${styles.sk}`} />
      <div className={`${styles.line} ${styles.lineShort} ${styles.sk}`} />
    </div>
  </div>
);

export const MessageSkeleton = ({ isOwn }) => (
  <div className={`${styles.msgRow} ${isOwn ? styles.msgOwn : ""}`}>
    {!isOwn && <div className={`${styles.circle} ${styles.circleSm} ${styles.sk}`} />}
    <div className={`${styles.bubble} ${isOwn ? styles.bubbleOwn : styles.bubbleOther} ${styles.sk}`} />
  </div>
);

export const StatusSkeleton = () => (
  <div className={styles.wrapper}>
    {/* My status row */}
    <div className={styles.statusRow}>
      <div className={`${styles.statusCircle} ${styles.sk}`} />
      <div className={styles.lines}>
        <div className={`${styles.line} ${styles.lineLong} ${styles.sk}`} />
        <div className={`${styles.line} ${styles.lineShort} ${styles.sk}`} />
      </div>
    </div>
    <div className={styles.statusLabel}>
      <div className={`${styles.line} ${styles.labelLine} ${styles.sk}`} />
    </div>
    {[1, 2, 3].map((i) => (
      <div key={i} className={styles.statusRow}>
        <div className={`${styles.statusCircle} ${styles.sk}`} />
        <div className={styles.lines}>
          <div className={`${styles.line} ${styles.lineLong} ${styles.sk}`} />
          <div className={`${styles.line} ${styles.lineShort} ${styles.sk}`} />
        </div>
      </div>
    ))}
  </div>
);

const SkeletonLoader = () => (
  <div className={styles.wrapper}>
    {[1,2,3,4,5,6].map(i => <ConversationSkeleton key={i} />)}
  </div>
);

export default SkeletonLoader;
